$(function() {
	
	//console.log('Mah..');
	var mr = window.FipeMarquee();
	mr.init($);
	//console.log(mr);

});


// WEBPACK FOOTER //
// ./scripts/autoload/marquee.js